import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ClearSharpIcon from "@mui/icons-material/ClearSharp";
import SendIcon from "@mui/icons-material/Send";
import ReplyIcon from "@mui/icons-material/Reply";
import { images } from "../../constants";
import "./Style.css";
import { getAsset } from "../../helpers/helper";
import { useSelector } from "react-redux";
import { useReplySuggestionMutation } from "../../features/timeline/timelineApiSlice";

const FALLBACK_AVATAR = images.noprofile;

const resolveAvatarSrc = (raw) => {
  if (!raw) return "";
  if (Array.isArray(raw)) {
    const first = raw.flat(Infinity).find(Boolean);
    return first ? String(first) : "";
  }
  if (typeof raw === "object") {
    return (
      raw.url ||
      raw.path ||
      raw.src ||
      raw.image ||
      raw.imageUrl ||
      ""
    );
  }
  const text = String(raw).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return text;
};

const CommentAvatar = ({ source, className }) => {
  const path = resolveAvatarSrc(source);
  const resolved = path ? getAsset(path) : "";
  // getAsset("") can return a broken "/assets/" URL — treat that as missing.
  const src =
    resolved && !resolved.endsWith("/assets/") && !resolved.endsWith("/assets")
      ? resolved
      : FALLBACK_AVATAR;
  return (
    <img
      src={src || FALLBACK_AVATAR}
      alt=""
      className={className}
      referrerPolicy="no-referrer"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = FALLBACK_AVATAR;
      }}
    />
  );
};

const Commentmodal = ({
  handleclose,
  handleSubmit,
  handleCommentChange,
  comments,
  id,
  postId,
  refetchComments,
  comment,
  composerIdentity,
  resolveCommentIdentity,
}) => {
  const { name } = useSelector((state) => state.user);
  const [visibleCommentsCount, setVisibleCommentsCount] = useState(20);
  const [replyInputVisible, setReplyInputVisible] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");
  const [suggestid, setSuggestId] = useState();
  const [replySuggestion] = useReplySuggestionMutation();

  const suggestions = Array.isArray(comments?.data?.suggestions)
    ? comments.data.suggestions
    : [];

  const composerImage =
    composerIdentity?.imageUrl?.length > 0
      ? composerIdentity.imageUrl
      : name?.imageUrl;

  const handleViewMore = () => {
    setVisibleCommentsCount((prevCount) => prevCount + 10);
  };

  const handleReplyIconClick = (index, suggestionId) => {
    setReplyInputVisible(replyInputVisible === index ? null : index);
    setSuggestId(suggestionId);
  };

  const handleReplyMessageChange = (e) => {
    setReplyMessage(e.target.value);
  };

  const handleReplySubmit = async () => {
    if (!suggestid || !replyMessage.trim()) {
      return;
    }

    try {
      let username = name?.fullname || name?.username || "";
      let imageUrl = Array.isArray(name?.imageUrl)
        ? name.imageUrl.filter(Boolean)
        : name?.imageUrl
          ? [name.imageUrl]
          : [];
      let shopid = id || null;

      if (typeof resolveCommentIdentity === "function") {
        const identity = await resolveCommentIdentity();
        username = identity.username || username;
        imageUrl = identity.imageUrl?.length ? identity.imageUrl : imageUrl;
        shopid = identity.shopid || null;
      }

      const response = await replySuggestion({
        suggestionId: suggestid,
        reply: [
          {
            userid: name?._id,
            shopid,
            username,
            role: "",
            imageUrl,
            message: replyMessage,
          },
        ],
      }).unwrap();

      if (response?.success) {
        setReplyMessage("");
        setReplyInputVisible(null);
        if (typeof refetchComments === "function" && postId) {
          refetchComments(postId);
        }
      }
    } catch (error) {
      console.error("Reply submit failed:", error);
    }
  };

  return (
    <div>
      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal.Dialog className="">
          <div className="noscroll Modal-head">
            <div className="d-flex justify-content-end cur-pointer">
              <ClearSharpIcon onClick={handleclose} alt="close" />
            </div>

            <Row className="pt-1">
              <Col
                lg={2}
                md={2}
                sm={2}
                xs={2}
                className="d-flex justify-content-center p-0"
              >
                <CommentAvatar
                  source={composerImage}
                  className="commentImg"
                />
              </Col>
              <Col
                className="inputComment ps-0"
                lg={10}
                md={10}
                sm={10}
                xs={10}
              >
                <div className="custom-input">
                  <div>
                    <input
                      placeholder="Write comment"
                      className=""
                      value={comment}
                      onChange={handleCommentChange}
                    />
                    <SendIcon onClick={handleSubmit} />
                  </div>
                </div>
              </Col>
            </Row>

            {suggestions.slice(0, visibleCommentsCount).map((suggestion, index) => (
              <Row
                className="pt-1"
                key={suggestion?._id || `comment-${index}`}
              >
                <Col
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className="d-flex justify-content-center p-0"
                >
                  <CommentAvatar
                    source={suggestion?.imageUrl}
                    className="commentImg-2"
                  />
                </Col>
                <Col
                  className="inputComment ps-0"
                  lg={10}
                  md={10}
                  sm={10}
                  xs={10}
                >
                  <div className="comment-header d-flex justify-content-between align-items-center mb-1">
                    <span className="comment-author">
                      {suggestion?.username ||
                        suggestion?.userName ||
                        "Anonymous"}
                    </span>
                    <ReplyIcon
                      className="reply-icon ms-2 cursor_P"
                      onClick={() =>
                        handleReplyIconClick(index, suggestion?._id)
                      }
                    />
                  </div>
                  <div className="pera-one">
                    <p className=" ps-2 py-3">{suggestion?.message}</p>
                  </div>

                  {suggestion?.replies?.map((reply, replyIndex) => (
                    <div
                      className="reply-box ps-3 pt-2 me-0 pb-2 mt-2"
                      key={reply?._id || `reply-${replyIndex}`}
                    >
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <CommentAvatar
                          source={reply?.imageUrl}
                          className="commentImg-2"
                        />
                        <span className="comment-author">
                          {reply?.username ||
                            reply?.userName ||
                            suggestion?.username ||
                            "Anonymous"}
                        </span>
                      </div>
                      <p className="reply-text mb-0">{reply?.message}</p>
                    </div>
                  ))}

                  {replyInputVisible === index && (
                    <div className=" mt-2">
                      <div className="custom-input">
                        <div>
                          <input
                            placeholder="Write a reply"
                            value={replyMessage}
                            onChange={handleReplyMessageChange}
                          />
                          <SendIcon onClick={handleReplySubmit} />
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            ))}

            {visibleCommentsCount < suggestions.length && (
              <div
                className="d-flex justify-content-center"
                onClick={handleViewMore}
              >
                <VisibilityIcon className="ph-icon" />
                <p className="ph-view ps-1">View More</p>
              </div>
            )}
          </div>
        </Modal.Dialog>
      </div>
    </div>
  );
};

export default Commentmodal;
